import { useState } from "react";
import { login } from "../../services/auth.service.js";
import AppError from "../../utils/AppError.js";
import getMessage from "../../utils/getMessage.js";
import { useLocation, useNavigate } from "react-router-dom";
import "../../styles/auth/auth.css";
import "../../styles/auth/login.css";
import AuthSubmitButton from "../../components/auth/AuthSubmitButton.jsx";
import PasswordInput from "../../components/auth/PasswordInput.jsx";
import EmailInput from "../../components/auth/EmailInput.jsx";
import ErrorText from "../../components/auth/ErrorText.jsx";
import ForgotPassword from "../../components/auth/ForgotPassword.jsx";
import GoToSignup from "../../components/auth/GoToSignup.jsx";

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError(null);
    setLoading(true);

    try {
      await login({ email, password });
      navigate(location.state?.from?.pathname || "/", { replace: true });
    } catch (error) {
      if (error instanceof AppError) {
        setError(error.message);
      } else {
        setError(getMessage("common", "error"));
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="outer">
      <h1 className="auth-heading">Login to VisualLab!</h1>
      <form onSubmit={handleSubmit} className="auth-form">
        <ErrorText error={error} />
        <EmailInput email={email} setEmail={setEmail} loading={loading} />
        <PasswordInput
          password={password}
          setPassword={setPassword}
          loading={loading}
        />
        <ForgotPassword loading={loading} />
        <AuthSubmitButton
          text="LOGIN"
          disabledText="Logging in..."
          loading={loading}
        />
        <GoToSignup loading={loading} />
      </form>
    </div>
  );
};

export default Login;
